import { zSchema } from "../../../schema-validation";

export const findUnmigratedWorkersSchema = zSchema.object({
  workerIds: zSchema.array(zSchema.string()),
});
